import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ehsan from "./ehsan.jpg";
import welcomeBg from "./images/welcome.jpg";
import mahsa from "./mahsa.jpg";

const boardMembers = [
  {
    name: "Dr. Ehsan Amjadian",
    role: "Chief Executive Officer (CEO)",
    img: ehsan,
  },
  {
    name: "Dr. Mahsa Ardali",
    role: "Chief Operating Officer (COO)",
    img: mahsa,
  },
];

const AboutUs = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.9)), url(${welcomeBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingTop: "80px",
        paddingBottom: "50px",
      }}
    >
      <Container maxWidth="lg">
        {/* Back to Home Button */}
        <Box sx={{ textAlign: "center", marginBottom: "40px" }}>
          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate("/")}
            sx={{
              color: "#00bcd4",
              borderColor: "#00bcd4",
              fontWeight: "bold",
              borderRadius: "25px",
              padding: "10px 25px",
              textTransform: "none",
              boxShadow: "0 0 10px rgba(0,188,212,0.5)",
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "rgba(0,188,212,0.1)",
                boxShadow: "0 0 20px rgba(0,188,212,0.8)",
              },
            }}
          >
            Back to Home
          </Button>
        </Box>

        {/* Title Section */}
        <Typography
          variant="h3"
          align="center"
          gutterBottom
          sx={{
            fontWeight: "bold",
            color: "white",
            textShadow: "0px 4px 15px rgba(0,0,0,0.7)",
          }}
        >
          About Ophthalmo Corp.
        </Typography>

        <Typography
          variant="h6"
          align="center"
          sx={{
            color: "#e0e0e0",
            maxWidth: "850px",
            margin: "20px auto 50px",
            lineHeight: 1.6,
          }}
        >
          Ophthalmo Corp. is a STEM-driven artificial intelligence company with
          a vision to create <strong>“a world where everyone sees.”</strong> Our
          mission is to free eye doctors from the growing administrative burden,
          enabling them to spend more—and higher quality—time caring for
          patients. We are proud to be part of Canada’s healthcare innovation
          landscape, combining advanced AI technology with a strong commitment
          to accessibility, security, and patient privacy.
        </Typography>

        {/* Vision / Mission Section */}
        <Box
          sx={{
            background: "rgba(255,255,255,0.1)",
            borderRadius: "15px",
            padding: "30px",
            marginBottom: "60px",
            textAlign: "center",
            color: "#b2ebf2",
            boxShadow: "0 4px 20px rgba(0,188,212,0.4)",
          }}
        >
          <Typography
            variant="h5"
            sx={{ fontWeight: "bold", marginBottom: "15px", color: "white" }}
          >
            Our Vision
          </Typography>

          <Typography variant="body1" sx={{ marginBottom: "15px" }}>
            <strong>Short-term (Today):</strong> Free up eye doctors from
            documentation burdens so they can focus on patients.
          </Typography>

          <Typography variant="body1" sx={{ marginBottom: "15px" }}>
            <strong>Mid-term (5–10 years):</strong> Achieve full automation
            across the clinical workflow, where AI anticipates needs and
            collaborates seamlessly with humans.
          </Typography>

          <Typography variant="body1">
            <strong>Long-term (10–50+ years):</strong> Reverse the growth of
            blindness and ultimately eradicate it, making eyesight fully
            recoverable no matter the cause.
          </Typography>
        </Box>

        {/* Board Section */}
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{
            fontWeight: "bold",
            color: "white",
            textShadow: "0px 4px 15px rgba(0,0,0,0.7)",
          }}
        >
          Meet Our Team
        </Typography>

        <Typography
          variant="h6"
          align="center"
          sx={{
            color: "#e0e0e0",
            maxWidth: "700px",
            margin: "auto",
            marginBottom: "50px",
          }}
        >
          Our leadership team brings together decades of experience in eye-care,
          optometry, and artificial intelligence technology — united by one
          mission: advancing the future of eye care through ethical and
          transformative AI.
        </Typography>

        {/* Cards */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: "30px",
            flexWrap: "wrap",
          }}
        >
          {boardMembers.map((member, index) => (
            <Card
              key={index}
              sx={{
                width: 280,
                textAlign: "center",
                borderRadius: "20px",
                background:
                  "linear-gradient(145deg, rgba(255,255,255,0.1), rgba(0,188,212,0.2))",
                backdropFilter: "blur(10px)",
                color: "white",
                boxShadow: "0 8px 20px rgba(0,0,0,0.6)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "translateY(-10px) scale(1.05)",
                  boxShadow: "0 12px 25px rgba(0,188,212,0.8)",
                },
              }}
            >
              <CardContent>
                <Avatar
                  src={member.img}
                  alt={member.name}
                  sx={{
                    width: 110,
                    height: 110,
                    margin: "auto",
                    border: "4px solid #00bcd4",
                  }}
                />
                <Typography
                  variant="h6"
                  sx={{
                    marginTop: "20px",
                    fontWeight: "bold",
                    textShadow: "0px 2px 8px rgba(0,0,0,0.6)",
                  }}
                >
                  {member.name}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: "#b2ebf2",
                    fontStyle: "italic",
                  }}
                >
                  {member.role}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default AboutUs;
